import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/BecomeMemberDialog.css";
import { WEB_LINK } from "utils/strings";

interface ConnectDialogProps {
  open: boolean;
  onClose: () => void;
}

const ConnectDialog: React.FC<ConnectDialogProps> = ({ open, onClose }) => {
  const handleConnectClick = () => {
    window.open(WEB_LINK.WHATSAPP_CHANNEL, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "become-member-dialog-container",
      }}
      BackdropProps={{
        className: "become-member-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="become-member-dialog-header">
          Enter the SABE Ecosystem ✨
        </div>
        <div className="become-member-dialog-divider"></div>
        <div className="become-member-dialog-containt-container">
          <p>
            Join a curated community of Remote Workers built with Focus,
            Clean Energy, and Long-Term Clarity.
          </p>
        </div>
        <div
          className="become-member-dialog-button"
          onClick={handleConnectClick}
        >
          <div>Yes</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectDialog;
